import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '../../utils/theme';

export default () => {
  return (
    <>
    <ThemeProvider>
      <Outlet/>
    </ThemeProvider>
    </>
  )
};